import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'checkbox']
  static values = {
    enabled: Boolean
  }

  declare readonly buttonTarget: HTMLInputElement
  declare readonly checkboxTargets: HTMLInputElement[]
  declare readonly hasButtonTarget: boolean
  declare enabledValue: boolean

  toggle (): void {
    this.enabledValue = !this.enabledValue
  }

  toggleWhenChecked (): void {
    this.buttonTarget.disabled = !this.checkboxTargets.some(checkbox => checkbox.checked)
  }

  private enabledValueChanged (): void {
    if (!this.hasButtonTarget) return

    this.buttonTarget.classList.toggle('enabled', this.enabledValue)
    this.buttonTarget.classList.toggle('disabled', !this.enabledValue)
  }
}
